import React from 'react';
import { MoreHorizontal, ClipboardList, UserCheck, Truck, MapPin, Brain, ShieldCheck, Building2, Activity, Scale, Eye, BarChart3 } from 'lucide-react';
export function SolutionSlide() {
  const platforms = [{
    name: 'Talabat',
    logo: 'https://cdn.magicpatterns.com/uploads/7756UG5Jym81A2wQ5NTmPg/Talabat_Logo.jpg'
  }, {
    name: 'Careem',
    logo: 'https://cdn.magicpatterns.com/uploads/7xRrJrg1q6oHJyA6jgCB5f/careem_logo.jpg'
  }, {
    name: 'Amazon',
    logo: 'https://cdn.magicpatterns.com/uploads/5ovEx7PeQYHdqRHWJccm3E/amazon_logo.jpg'
  }, {
    name: 'Noon',
    logo: 'https://cdn.magicpatterns.com/uploads/tD7MZW9eSLEFkb5TBBWD9M/noon_logo.png'
  }, {
    name: 'Other Platforms',
    icon: <MoreHorizontal className="w-6 h-6 text-gray-500" data-id="element-499" />
  }];
  const capabilities = [{
    name: 'Orders Data',
    desc: 'Customer details, items, payment, delivery info',
    icon: <ClipboardList className="w-5 h-5 text-[#2EBCB0]" data-id="element-500" />
  }, {
    name: 'Driver Identity',
    desc: 'Verified driver information',
    icon: <UserCheck className="w-5 h-5 text-[#2EBCB0]" data-id="element-501" />
  }, {
    name: 'Vehicle Data',
    desc: 'Assigned vehicle details from Pair2 system',
    icon: <Truck className="w-5 h-5 text-[#2EBCB0]" data-id="element-502" />
  }, {
    name: 'Real-Time Tracking',
    desc: 'Live location and activity',
    icon: <MapPin className="w-5 h-5 text-[#2EBCB0]" data-id="element-503" />
  }, {
    name: 'AI Monitoring',
    desc: 'Behavioral analysis and alerts',
    icon: <Brain className="w-5 h-5 text-[#2EBCB0]" data-id="element-504" />
  }, {
    name: 'Compliance Engine',
    desc: 'Rules, violations, enforcement logic',
    icon: <ShieldCheck className="w-5 h-5 text-[#2EBCB0]" data-id="element-505" />
  }];
  const outputs = [{
    name: 'Authorities Access',
    desc: 'Search, monitoring, investigation',
    icon: <Building2 className="w-5 h-5 text-gray-700" data-id="element-506" />
  }, {
    name: 'Real-Time Monitoring',
    desc: 'Live visibility of operations',
    icon: <Activity className="w-5 h-5 text-gray-700" data-id="element-507" />
  }, {
    name: 'Compliance Enforcement',
    desc: 'Violations, actions, penalties',
    icon: <Scale className="w-5 h-5 text-gray-700" data-id="element-508" />
  }, {
    name: 'Full Visibility',
    desc: 'Orders, drivers, vehicles, history',
    icon: <Eye className="w-5 h-5 text-gray-700" data-id="element-509" />
  }, {
    name: 'Data Insights',
    desc: 'Analytics and reporting',
    icon: <BarChart3 className="w-5 h-5 text-gray-700" data-id="element-510" />
  }];
  return <div className="flex flex-col w-screen h-screen overflow-hidden bg-white text-[#1a1a2e] px-12 py-8" data-id="element-511">
      {/* Top Header */}
      <div className="flex justify-between items-start shrink-0" data-id="element-512">
        <img src="https://cdn.magicpatterns.com/uploads/wGUVVF9ppu2J6VxJ2kpoN3/Pair2_Logo.png" alt="Pair2 Logo" className="h-10 w-auto object-contain" data-id="element-513" />
      </div>

      {/* Title */}
      <div className="text-center mt-2 mb-8 shrink-0" data-id="element-514">
        <span className="text-sm font-semibold text-[#2EBCB0] uppercase tracking-widest" data-id="element-515">
          The Solution
        </span>
        <h1 className="text-[1.75rem] font-bold text-[#1a1a2e] mt-2" data-id="element-516">
          A Unified National Platform for Delivery Monitoring & Control
        </h1>
      </div>

      {/* Main Architecture Diagram */}
      <div className="flex-grow flex items-stretch justify-between max-w-7xl mx-auto w-full relative mb-6" data-id="element-517">
        {/* LEFT COLUMN: Platforms */}
        <div className="w-[20%] flex flex-col z-10" data-id="element-518">
          <h2 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-6 text-center" data-id="element-519">
            Delivery Platforms & Marketplaces
          </h2>
          <div className="flex flex-col justify-between flex-grow pb-4" data-id="element-520">
            {platforms.map((platform, idx) => <div key={idx} className="flex items-center gap-3 bg-white border border-gray-200 rounded-xl p-3 shadow-sm hover:shadow-md transition-shadow relative group" data-id="element-521">
                <div className="w-10 h-10 rounded-lg overflow-hidden border border-gray-100 flex items-center justify-center bg-gray-50 shrink-0" data-id="element-522">
                  {platform.logo ? <img src={platform.logo} alt={platform.name} className="w-full h-full object-cover" data-id="element-523" /> : platform.icon}
                </div>
                <span className="font-medium text-[0.9375rem] text-gray-800" data-id="element-524">
                  {platform.name}
                </span>
                {/* Connection point for SVG */}
                <div className="absolute right-0 top-1/2 w-2 h-2 bg-gray-300 rounded-full translate-x-1/2 -translate-y-1/2" data-id="element-525"></div>
              </div>)}
          </div>
        </div>

        {/* SVG CONNECTIONS: Left to Center */}
        <div className="w-[10%] relative shrink-0" data-id="element-526">
          <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 500" preserveAspectRatio="none" data-id="element-527">
            <defs data-id="element-528">
              <marker id="arrowhead-teal" markerWidth="8" markerHeight="6" refX="7" refY="3" orient="auto" data-id="element-529">
                <polygon points="0 0, 8 3, 0 6" fill="#2EBCB0" data-id="element-530" />
              </marker>
            </defs>
            {[50, 150, 250, 350, 450].map((y, i) => <g key={i} data-id="element-531">
                {/* Static background line */}
                <path d={`M 0 ${y} C 50 ${y}, 50 250, 100 250`} fill="none" stroke="#2EBCB0" strokeWidth="1.5" opacity="0.15" data-id="element-532" />
                {/* Animated flowing line */}
                <path d={`M 0 ${y} C 50 ${y}, 50 250, 100 250`} fill="none" stroke="#2EBCB0" strokeWidth="2" strokeDasharray="8 12" opacity="0.6" markerEnd="url(#arrowhead-teal)" className="flow-line-left" style={{
              animationDelay: `${i * 0.2}s`
            }} data-id="element-533" />
              </g>)}
          </svg>
        </div>

        {/* CENTER COLUMN: Pair2 Platform */}
        <div className="w-[40%] flex flex-col justify-center z-10 relative" data-id="element-534">
          <div className="text-center mb-4 absolute -top-8 left-0 right-0" data-id="element-535">
            <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider bg-white px-3" data-id="element-536">
              Mandatory Integration Layer
            </span>
          </div>

          <div className="bg-white border-2 border-[#2EBCB0]/30 rounded-2xl shadow-lg overflow-hidden relative" data-id="element-537">
            {/* Teal accent line */}
            <div className="absolute left-0 top-0 bottom-0 w-2 bg-[#2EBCB0]" data-id="element-538"></div>

            <div className="p-6 pl-8" data-id="element-539">
              <div className="flex items-center justify-center gap-3 mb-6 pb-4 border-b border-gray-100" data-id="element-540">
                <img src="https://cdn.magicpatterns.com/uploads/wGUVVF9ppu2J6VxJ2kpoN3/Pair2_Logo.png" alt="Pair2" className="h-8" data-id="element-541" />
                <h3 className="text-xl font-bold text-[#1a1a2e]" data-id="element-542">
                  National Platform
                </h3>
              </div>

              <div className="grid grid-cols-2 gap-x-6 gap-y-5" data-id="element-543">
                {capabilities.map((cap, idx) => <div key={idx} className="flex items-start gap-3" data-id="element-544">
                    <div className="mt-0.5 shrink-0 p-1.5 bg-[#2EBCB0]/10 rounded-md" data-id="element-545">
                      {cap.icon}
                    </div>
                    <div data-id="element-546">
                      <h4 className="font-semibold text-sm text-[#1a1a2e] mb-0.5" data-id="element-547">
                        {cap.name}
                      </h4>
                      <p className="text-[0.75rem] text-gray-500 leading-tight" data-id="element-548">
                        {cap.desc}
                      </p>
                    </div>
                  </div>)}
              </div>
            </div>

            {/* Connection points */}
            <div className="absolute left-0 top-1/2 w-3 h-3 bg-[#2EBCB0] rounded-full -translate-x-1.5 -translate-y-1/2 border-2 border-white" data-id="element-549"></div>
            <div className="absolute right-0 top-1/2 w-3 h-3 bg-[#2EBCB0] rounded-full translate-x-1.5 -translate-y-1/2 border-2 border-white" data-id="element-550"></div>
          </div>
        </div>

        {/* SVG CONNECTIONS: Center to Right */}
        <div className="w-[10%] relative shrink-0" data-id="element-551">
          <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 500" preserveAspectRatio="none" data-id="element-552">
            <defs data-id="element-553">
              <marker id="arrowhead-teal-right" markerWidth="8" markerHeight="6" refX="7" refY="3" orient="auto" data-id="element-554">
                <polygon points="0 0, 8 3, 0 6" fill="#2EBCB0" data-id="element-555" />
              </marker>
            </defs>
            {[50, 150, 250, 350, 450].map((y, i) => <g key={i} data-id="element-556">
                {/* Static background line */}
                <path d={`M 0 250 C 50 250, 50 ${y}, 100 ${y}`} fill="none" stroke="#2EBCB0" strokeWidth="1.5" opacity="0.15" data-id="element-557" />
                {/* Animated flowing line */}
                <path d={`M 0 250 C 50 250, 50 ${y}, 100 ${y}`} fill="none" stroke="#2EBCB0" strokeWidth="2" strokeDasharray="8 12" opacity="0.6" markerEnd="url(#arrowhead-teal-right)" className="flow-line-right" style={{
              animationDelay: `${1 + i * 0.2}s`
            }} data-id="element-558" />
              </g>)}
          </svg>
        </div>

        {/* RIGHT COLUMN: Outputs */}
        <div className="w-[20%] flex flex-col z-10" data-id="element-559">
          <h2 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-6 text-center" data-id="element-560">
            Authorities & Ecosystem Control
          </h2>
          <div className="flex flex-col justify-between flex-grow pb-4" data-id="element-561">
            {outputs.map((output, idx) => <div key={idx} className="flex items-start gap-3 bg-gray-50 border border-gray-200 rounded-xl p-3 relative" data-id="element-562">
                {/* Connection point for SVG */}
                <div className="absolute left-0 top-1/2 w-2 h-2 bg-gray-300 rounded-full -translate-x-1/2 -translate-y-1/2" data-id="element-563"></div>

                <div className="mt-0.5 shrink-0 bg-white p-1.5 rounded-md border border-gray-200 shadow-sm" data-id="element-564">
                  {output.icon}
                </div>
                <div data-id="element-565">
                  <h4 className="font-semibold text-[0.875rem] text-[#1a1a2e] mb-0.5 leading-tight" data-id="element-566">
                    {output.name}
                  </h4>
                  <p className="text-[0.75rem] text-gray-500 leading-tight" data-id="element-567">
                    {output.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>

      {/* Bottom Tagline */}
      <div className="text-center shrink-0 mt-auto pb-4" data-id="element-568">
        <p className="text-[0.9375rem] italic text-gray-500" data-id="element-569">
          "From fragmented platforms to a unified, controlled, and transparent
          delivery ecosystem."
        </p>
      </div>
    </div>;
}